module.exports = __webpack_public_path__ + "static/img/use01.9389dd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/course/mo/use01.png
// module id = mATo
// module chunks = 10